import React from 'react';
import { motion } from 'framer-motion';
interface RevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li';
}
/** Replica el efecto ".reveal" del ejemplo: fade + subida al entrar en viewport. */
export function Reveal({
  children,
  className,
  delay = 0,
  as = 'div'
}: RevealProps) {
  const MotionTag = as === 'li' ? motion.li : motion.div;
  return <MotionTag className={className} initial={{
    opacity: 0,
    y: 18
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.15
  }} transition={{
    duration: 0.6,
    ease: 'easeOut',
    delay
  }} data-id="element-116">
      {children}
    </MotionTag>;
}